import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ThemedLogo from '@/components/ThemedLogo';

const SidebarNav = () => {
  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <ThemedLogo variant="default" width={{ xs: 60, md: 70 }} />
      </Box>
      <Box paddingX={2} paddingY={2}>
        <Box marginTop={2}>
          <Button
            size={'large'}
            variant="outlined"
            fullWidth
            component="a"
            href="/auth/signin"
          >
            Sign In / Sign Up
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarNav;
